// api.ts
import { API_ENDPOINT } from "@/lib/constants";
import axios from "axios";
import Cookies from "js-cookie";

function getCookie(name: string): string | null {
  let cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    const cookies = document.cookie.split(";");
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      // Does this cookie string begin with the name we want?
      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

const myaxios = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true, // This is required for CSRF to work with cross-origin requests
});

// Add a request interceptor to set the CSRF token and auth token
myaxios.interceptors.request.use(
  (config) => {
    // Get the CSRF token from the cookie
    const csrfToken = getCookie("csrftoken");
    if (csrfToken) {
      // Set the CSRF token in the header
      config.headers["X-CSRFToken"] = csrfToken;
    }

    // Get the auth token from the cookie
    const authToken = getCookie("auth_token");
    if (authToken) {
      config.headers["Authorization"] = `Bearer ${authToken}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle authentication errors
myaxios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear the invalid auth token
      Cookies.remove("auth_token");

      // Redirect to login page if not already there
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default myaxios;
